export default __webpack_public_path__ + "static/media/79.cc68d075.gif";